<template>
  <div>
    <com-dialog :visible.sync="visible" width="600px" title="绑定用户">
      <div>
        <div class="flex items-center">
          <div class="form_item flex items-center">
            <div class="label">绑定用户</div>
            <el-select
              v-model="form.refUser"
              filterable
              remote
              clearable
              placeholder="请输入关键词"
              :remote-method="getUserList"
            >
              <el-option v-for="item in userList" :key="item.code" :label="item.phone" :value="item.code"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleAdd">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { bandCard } from '@/api/electric_card'
import { userListApi } from '@/api/user'

export default {
  data() {
    return {
      visible: false,
      title: '新增',
      form: {},
      userList: []
    }
  },

  methods: {
    getUserList(val) {
      userListApi({phone: val}).then(res => {
        this.userList = res.data.records
      })
    },
    handleUpdate() {
      update(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    handleAdd() {
      bandCard(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    open(row) {
      this.visible = true
      this.form = {}
      this.form.code = row.code
    },
    close() {
      this.visible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  margin-bottom: 20px;
  .label {
    width: 100px;
    flex-shrink: 0;
    margin-right: 10px;
    text-align: right;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding-left: 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
